// sowinrwFilter.js

/**
 * Initialisiert die Filter-Dropdowns der Sowi-NRW-Collections.
 *
 * @param {Document|HTMLElement} root      Bereich, in dem nach .collection gesucht wird
 * @param {Object}               filterMap Optional: Dropdown-Feldcode → data-Attribut an der Kachel,
 *                                         nur nötig, wenn beide unterschiedlich heißen
 */
export function initCollectionFilters(root = document, filterMap = {}) {
    root.querySelectorAll('.collection').forEach(function (area) {
        var selects = Array.prototype.slice.call(area.querySelectorAll('.collection_sowinrw_filter'));
        if (!selects.length) {
            return;
        }

        function getKey(select) {
            return filterMap[select.dataset.filter] || select.dataset.filter;
        }

        // Kacheln einmalig mit ihren (getrimmten) Werten einlesen
        var columns = Array.prototype.slice.call(area.querySelectorAll('.sowinrwColumn')).map(function (column) {
            var tile = column.querySelector('.sowinrw');
            var data = {};
            selects.forEach(function (select) {
                var key = getKey(select);
                data[key] = tile ? (tile.dataset[key] || '').trim() : '';
            });
            return { element: column, data: data };
        });

        // Prüft, ob eine Kachel zu allen gewählten Filtern passt (optional einen Filter ignorieren)
        function matches(column, ignoreSelect) {
            return selects.every(function (select) {
                if (select === ignoreSelect || select.value === '') {
                    return true; // Platzhalter = ungefiltert
                }
                return column.data[getKey(select)] === select.value.trim();
            });
        }

        function updateOptions() {
            selects.forEach(function (select) {
                var key = getKey(select);
                var available = {};

                // Werte sammeln, die mit den anderen Filtern noch vorkommen
                columns.forEach(function (column) {
                    if (matches(column, select)) {
                        available[column.data[key]] = true;
                    }
                });

                Array.prototype.forEach.call(select.options, function (option) {
                    if (option.value === '') {
                        return; // Platzhalter nicht verändern
                    }
                    var isAvailable = available[option.value.trim()] === true;
                    option.disabled = !isAvailable;
                    option.hidden = !isAvailable;
                });

                // Falls die aktuelle Auswahl nicht mehr verfügbar ist: auf Platzhalter zurücksetzen
                if (select.value !== '' && select.selectedOptions[0] && select.selectedOptions[0].disabled) {
                    select.selectedIndex = 0;
                }
            });
        }

        function applyFilters() {
            updateOptions();
            columns.forEach(function (column) {
                column.element.style.display = matches(column, null) ? '' : 'none';
            });
        }

        selects.forEach(function (select) {
            select.addEventListener('change', applyFilters);
        });

        // Initial ausführen
        applyFilters();
    });
}